import { createSelector } from 'reselect';

const selectCancelReasons = (state: any) => state.cancelReasons;


export const selectCancelReasonsCurrentItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.current);

export const selectCancelReasonsListItems = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.list);

export const selectBrandItemById = (itemId: any) =>
    createSelector(selectCancelReasonsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBrandQueryItems = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.query);

export const selectBrandCreatedItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.create);

export const selectBrandUpdatedItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.update);

export const selectReadItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.read);

export const selectBrandDeletedItem = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.delete);

export const selectCancelReasonsearchedItems = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.search);

export const selectBrandItemsCount = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.count);

export const selectBrandItemsFilter = createSelector([selectCancelReasons], (cancelReasons) => cancelReasons.filter);